import { addDays, getDay, isAfter, isValid, parse, startOfDay } from 'date-fns';
import { RuleProps } from 'types/application';
import { IMPORT_DETAILS, REMARKS, SUBTITLES_DETAILS, TITLE_DETAILS } from './SubmissionofNewTitles';
import { isEnglish } from 'features/applicationPage/helpers';

export const INFORMATION_ON_FILM = 'information-on-film';

const filmsNonProfit = ['FMNFP'];

const SUBMISSION_OF_FILMS_WITH_PARTY_POLITICAL_CONTENT = [
    {
        sectionID: IMPORT_DETAILS,
        sectionName: 'Format Details',
        fieldList: [
            {
                id: 'format',
                label: 'Format',
                type: 'dropdown',
                apiID: 'IMDA-IRIS-Work-Films-Format',
                hasLabelInfo: true,
                rule: { required: true }
            },
            {
                id: 'type',
                label: 'Type',
                type: 'dropdown',
                apiID: 'IMDA-IRIS-Work-Films-Type',
                rule: {
                    required: true,
                    disabled: true,
                    setValue: ({ currentValue }: RuleProps) => {
                        const result = currentValue === '' ? 'FTR' : currentValue;
                        return result;
                    }
                }
            },
            {
                id: 'online-link',
                label: 'Online Link',
                type: 'url',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                },
                labelNote:
                    'If you have multiple links, please enter one of the links in the mandatory field. Save all links in an editable file type (e.g. .doc, .docx, .xls, .txt or .rtf) and upload it in the “Attachment upload” section.'
            },
            {
                id: 'id-username',
                label: 'ID/Username',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                }
            },
            {
                id: 'password',
                label: 'Password',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                }
            },
            // {
            //     id: 'dcp-ready-date',
            //     label: 'DCP Ready Date',
            //     type: 'date',
            //     rule: {
            //         baseIds: [`${IMPORT_DETAILS}-format`],
            //         required: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(
            //                 baseValues &&
            //                     (baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP')
            //             );
            //             return result;
            //         },
            //         hidden: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(
            //                 baseValues &&
            //                     !(
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP'
            //                     )
            //             );
            //             return result;
            //         },
            //         customValidate: ({ currentValue }: RuleProps) => {
            //             const currentDate = new Date();
            //             const formatter = new Intl.DateTimeFormat('en', {
            //                 weekday: 'short',
            //                 month: 'short',
            //                 day: '2-digit',
            //                 year: 'numeric'
            //             });
            //             const formattedDate = formatter.format(currentDate);

            //             if (currentValue && new Date(currentValue as string) < new Date(formattedDate)) {
            //                 return 'Must select current date or future date';
            //             }
            //         }
            //     }
            // },
            {
                id: 'kdm-required',
                label: 'Is Key Delivery Message (KDM) required?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            !(
                                baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP'
                            )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'other-format',
                label: 'Other Format',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] === 'OTH');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH');
                        return result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string)) {
                            return 'Only English inputs are accepted';
                        }
                    }
                }
            },
            {
                id: 'no-of-pieces',
                label: 'No. of Pieces',
                type: 'number',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'TPOFD')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (Number(currentValue) <= 0) {
                            return 'Must be greater than zero';
                        }
                    }
                }
            },
            {
                id: 'dateCombo',
                label: 'Preferred Date of Media Submission',
                type: 'dateRadio',
                span: 12,
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    }
                },
                preField: {
                    id: 'radio-day',
                    label: ' ',
                    type: 'radio',
                    // defaultValue: 'AM',
                    options: [
                        {
                            optID: 'AM',
                            optLabel: 'AM'
                        },
                        {
                            optID: 'PM',
                            optLabel: 'PM'
                        }
                        // {
                        //     optID: 'Full Day',
                        //     optLabel: 'Full Day'
                        // }
                    ],
                    labelNote: "Media submission appointment subject to IMDA's confirmation."
                },
                mainField: {
                    id: 'main',
                    type: 'date2',
                    rule: {
                        baseIds: [`${IMPORT_DETAILS}-format`],
                        required: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                            return result;
                        },
                        dateLimit: () => {
                            const currentDate = new Date();
                            return { minDate: new Date(), maxDate: new Date().setDate(currentDate.getDate() + 30) };
                        },
                        customValidate: ({ currentValue }: RuleProps) => {
                            if (!currentValue) return;

                            const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                            if (!isValid(selectedDate)) return 'Invalid Date';

                            const today = startOfDay(new Date());
                            const maxDate = addDays(today, 30);

                            if (selectedDate < today) {
                                return 'Must select current date or future date';
                            }

                            if (isAfter(selectedDate, maxDate)) {
                                return 'Date must not be more than 30 days from today';
                            }

                            const day = getDay(selectedDate);
                            if (day === 0 || day === 6) {
                                return 'Weekend dates are not allowed';
                            }

                            return true;
                        },
                        disabledWeekend: true
                    }
                }
            }
        ]
    },
    {
        sectionID: TITLE_DETAILS,
        sectionName: 'Title Details',
        fieldList: [
            {
                id: 'language-group',
                apiID: 'LanguageGroup',
                label: 'Language Group',
                type: 'dropdown',
                rule: { required: true }
            },
            {
                id: 'sub-language-group',
                apiID: 'SubLanguageGroup',
                label: 'Sub-Language Group',
                type: 'dropdown',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`],
                    optionGroup: `${TITLE_DETAILS}-language-group`,
                    required: true
                }
            },
            {
                id: 'other-language-desc',
                label: 'Other Language',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`, `${TITLE_DETAILS}-sub-language-group`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${TITLE_DETAILS}-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'OTH')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            !(
                                baseValues[`${TITLE_DETAILS}-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'OTH'
                            )
                        );
                        return result;
                    }
                }
            },
            // {
            //     id: 'language-desc',
            //     label: 'Language Description',
            //     type: 'text',
            //     rule: {
            //         baseIds: [`${TITLE_DETAILS}-sub-language-group`],
            //         required: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'XX');
            //             return result;
            //         },
            //         hidden: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-sub-language-group`] !== 'XX');
            //             return result;
            //         }
            //     }
            // },
            {
                id: 'application-form',
                label: '',
                type: 'text',
                rule: { hidden: true }
            },
            {
                id: 'title',
                label: 'Title',
                type: 'text',
                rule: { required: true }
            },
            {
                id: 'romaised-title',
                label: 'Romanised Title',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`, `${TITLE_DETAILS}-sub-language-group`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-language-group`] !== 'EN');
                        return result;
                    },
                    customValidate: ({ baseValues, currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string) && baseValues && baseValues[`${TITLE_DETAILS}-language-group`] !== 'EN') {
                            return 'Only English inputs are accepted';
                        }
                    }
                }
            },
            {
                id: 'also-known-as',
                label: 'Also Known As',
                type: 'text'
            },
            {
                id: 'producer',
                label: 'Producer',
                type: 'text',
                rule: { required: true }
            },
            {
                id: 'place-production',
                label: 'Place of Production',
                type: 'dropdown',
                options: [
                    { optID: 'singapore', optLabel: 'Singapore' },
                    { optID: 'malaysia', optLabel: 'Malaysia' },
                    { optID: 'china', optLabel: 'China' },
                    { optID: 'hongKong', optLabel: ' Hong Kong' },
                    { optID: 'india', optLabel: 'India' },
                    { optID: 'japan', optLabel: 'Japan' },
                    { optID: 'taiwan', optLabel: 'Taiwan' },
                    { optID: 'unitedKingdom', optLabel: 'United Kingdom' },
                    { optID: 'unitedStates', optLabel: 'United States' },
                    { optID: 'OTH', optLabel: 'Others' }
                ],
                rule: { required: true }
            },
            {
                id: 'year-production',
                label: 'Year of Production',
                type: 'number',
                rule: { required: true, charLength: 4 }
            },
            {
                id: 'other-place-of-production',
                label: 'Other Place of Production',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-place-production`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-place-production`] === 'OTH');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-place-production`] !== 'OTH');
                        return result;
                    }
                }
            },
            {
                id: 'director',
                label: 'Director',
                type: 'text',
                rule: { required: true }
            },
            {
                id: 'running-time',
                label: 'Running Time (in minutes)',
                type: 'number',
                rule: { charLength: 6, required: true }
            },
            {
                id: 'submission-purpose',
                label: 'Purpose of Submission',
                type: 'dropdown',
                options: [
                    { optID: 'TR', optLabel: 'Theatrical Release' },
                    { optID: 'OTH', optLabel: 'Others' }
                ],
                rule: {
                    baseIds: [`${TITLE_DETAILS}-application-form`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(
                            baseValues && filmsNonProfit.includes(baseValues[`${TITLE_DETAILS}-application-form`]?.toString())
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && filmsNonProfit.includes(baseValues[`${TITLE_DETAILS}-application-form`]?.toString())
                        );
                        return result;
                    }
                }
            },
            {
                id: 'submission-purpose-non-profit',
                label: 'Purpose of Submission',
                type: 'dropdown',
                options: [
                    { optID: 'FF', optLabel: 'Film Festival' },
                    { optID: 'OTH', optLabel: 'Others' }
                ],
                rule: {
                    baseIds: [`${TITLE_DETAILS}-application-form`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && filmsNonProfit.includes(baseValues[`${TITLE_DETAILS}-application-form`]?.toString())
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(
                            baseValues && filmsNonProfit.includes(baseValues[`${TITLE_DETAILS}-application-form`]?.toString())
                        );
                        return result;
                    }
                }
            },
            {
                id: 'nature-of-event-activity',
                label: 'Nature or Name of Event/Activity',
                type: 'text',
                rule: {
                    baseIds: [
                        `${TITLE_DETAILS}-application-form`,
                        `${TITLE_DETAILS}-submission-purpose`,
                        `${TITLE_DETAILS}-submission-purpose-non-profit`
                    ],
                    required: ({ baseValues }: RuleProps) => {
                        const applicationForm = baseValues && baseValues[`${TITLE_DETAILS}-application-form`]?.toString();
                        const result = filmsNonProfit?.includes(applicationForm ?? '')
                            ? true
                            : Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] === 'OTH');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const applicationForm = baseValues && baseValues[`${TITLE_DETAILS}-application-form`]?.toString();
                        const result = filmsNonProfit?.includes(applicationForm ?? '')
                            ? false
                            : Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] !== 'OTH');
                        return result;
                    }
                }
            },
            // {
            //     id: 'submission-extra-features',
            //     label: 'Does your submission include Extra Features?',
            //     type: 'radio',
            //     options: [
            //         {
            //             optID: 'Yes',
            //             optLabel: 'Yes'
            //         },
            //         {
            //             optID: 'No',
            //             optLabel: 'No'
            //         }
            //     ],
            //     rule: {
            //         baseIds: [
            //             `${TITLE_DETAILS}-application-form`,
            //             `${TITLE_DETAILS}-submission-purpose`,
            //             `${TITLE_DETAILS}-submission-purpose-non-profit`
            //         ],
            //         required: ({ baseValues }: RuleProps) => {
            //             const applicationForm = baseValues && baseValues[`${TITLE_DETAILS}-application-form`]?.toString();
            //             const result = filmsNonProfit?.includes(applicationForm ?? '')
            //                 ? Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] === 'OTH')
            //                 : Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] === 'OTH');
            //             return result;
            //         },
            //         hidden: ({ baseValues }: RuleProps) => {
            //             const applicationForm = baseValues && baseValues[`${TITLE_DETAILS}-application-form`]?.toString();
            //             const result = filmsNonProfit?.includes(applicationForm ?? '')
            //                 ? Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] !== 'OTH')
            //                 : Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] !== 'OTH');
            //             return result;
            //         }
            //     }
            // },
            // {
            //     id: 'classify-extra-features',
            //     label: 'Do you want to classify these Extra Features?',
            //     type: 'radio',
            //     options: [
            //         {
            //             optID: 'Yes',
            //             optLabel: 'Yes'
            //         },
            //         {
            //             optID: 'No',
            //             optLabel: 'No'
            //         }
            //     ],
            //     rule: {
            //         baseIds: [
            //             `${TITLE_DETAILS}-application-form`,
            //             `${TITLE_DETAILS}-submission-purpose`,
            //             `${TITLE_DETAILS}-submission-purpose-non-profit`,
            //             `${TITLE_DETAILS}-submission-extra-features`
            //         ],
            //         required: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-extra-features`] === 'Yes');
            //             return result;
            //         },
            //         hidden: ({ baseValues }: RuleProps) => {
            //             const applicationForm = baseValues && baseValues[`${TITLE_DETAILS}-application-form`]?.toString();
            //             const result = filmsNonProfit.includes(applicationForm ?? '')
            //                 ? Boolean(
            //                       baseValues &&
            //                           (baseValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] !== 'OTH' ||
            //                               baseValues[`${TITLE_DETAILS}-submission-extra-features`] !== 'Yes')
            //                   )
            //                 : Boolean(
            //                       baseValues &&
            //                           (baseValues[`${TITLE_DETAILS}-submission-purpose`] !== 'OTH' ||
            //                               baseValues[`${TITLE_DETAILS}-submission-extra-features`] !== 'Yes')
            //                   );
            //             return result;
            //         }
            //     }
            // },
            {
                id: 'screening-date',
                label: 'Screening Date',
                type: 'table',
                rule: { required: true, single: true },
                subFields: [
                    {
                        id: 'from',
                        header: 'From',
                        type: 'date2',
                        rule: {
                            baseIds: [`${TITLE_DETAILS}-screening-date.0.to`],
                            required: true,
                            dateLimit: () => {
                                return { minDate: new Date() };
                            },
                            revalidate: [`${TITLE_DETAILS}-screening-date.0.to`],
                            customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                if (!currentValue) return;

                                const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                                if (!isValid(selectedDate)) return 'Invalid Date';

                                const today = startOfDay(new Date());

                                if (selectedDate < today) {
                                    return 'Must select current date or future date';
                                }

                                const toValue = baseValues?.[`${TITLE_DETAILS}-screening-date.0.to`];

                                if (toValue) {
                                    const toDate = parse(toValue as string, 'yyyy-MM-dd', new Date());

                                    if (isValid(toDate) && isValid(selectedDate)) {
                                        if (toDate < selectedDate) {
                                            return 'Date/Time From cannot be later than Date/Time To';
                                        }
                                    }
                                }

                                return true;
                            }
                        }
                    },
                    {
                        id: 'to',
                        header: 'To',
                        type: 'date2',
                        rule: {
                            baseIds: [`${TITLE_DETAILS}-screening-date.0.from`],
                            required: true,
                            dateLimit: () => {
                                return { minDate: new Date() };
                            },
                            revalidate: [`${TITLE_DETAILS}-screening-date.0.from`],
                            customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                if (!currentValue) return;

                                const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                                if (!isValid(selectedDate)) return 'Invalid Date';

                                const today = startOfDay(new Date());

                                if (selectedDate < today) {
                                    return 'Must select current date or future date';
                                }

                                const fromValue = baseValues?.[`${TITLE_DETAILS}-screening-date.0.from`];

                                if (fromValue) {
                                    const fromDate = parse(fromValue as string, 'yyyy-MM-dd', new Date());

                                    if (isValid(fromDate) && isValid(selectedDate)) {
                                        if (fromDate > selectedDate) {
                                            return 'Date/Time From cannot be later than Date/Time To';
                                        }
                                    }
                                }

                                return true;
                            }
                        }
                    }
                ],
                span: 12
            },
            {
                id: 'screening-venue',
                label: 'Screening Venue',
                type: 'text',
                rule: { required: true }
            }
        ]
    },
    {
        sectionID: SUBTITLES_DETAILS,
        sectionName: 'Subtitles',
        fieldList: [
            {
                id: 'subtitle-1',
                label: 'Subtitle 1',
                apiID: 'IMDA-IRIS-Work-Films-Subtitle',
                type: 'dropdown'
            },
            {
                id: 'subtitle-2',
                label: 'Subtitle 2',
                apiID: 'IMDA-IRIS-Work-Films-Subtitle',
                type: 'dropdown'
            }
        ]
    },
    {
        sectionID: REMARKS,
        sectionName: '',
        fieldList: [
            {
                id: 'remarks',
                label: 'Remarks',
                placeholder: 'Free Text',
                type: 'longText',
                textRows: 4,
                span: 12
            },
            {
                id: 'attachments',
                label: 'Attachment Upload',
                type: 'file',
                category: 'SupportingDocuments',
                fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    // 'text/plain',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    // 'image/gif',
                    'image/bmp',
                    'video/quicktime',
                    'video/mp4',
                    'video/mpeg'
                ]
            },
            {
                id: 'link-to-attachments',
                label: 'Link to Supporting Documents',
                type: 'url',
                labelNote: 'For files greater than 10MB or in a different file type, you may provide a link. e.g. Dropbox, GoogleDrive.'
            }
        ]
    },
    {
        sectionID: INFORMATION_ON_FILM,
        sectionName: 'Information on Film',
        fieldList: [
            {
                id: 'made',
                label: 'The film is made by or on behalf of a political party? (please tick the relevant box)',
                apiID: '',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                span: 12,
                rule: { required: true }
            },
            {
                id: 'made-political-name',
                label: 'Name of Political Party',
                type: 'text',
                rule: {
                    baseIds: [`${INFORMATION_ON_FILM}-made`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${INFORMATION_ON_FILM}-made`] === 'Yes');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result =
                            Boolean(baseValues && baseValues[`${INFORMATION_ON_FILM}-made`] === 'No') ||
                            Boolean(baseValues && baseValues[`${INFORMATION_ON_FILM}-made`] === '');
                        return result;
                    }
                }
            },
            {
                id: 'submitted',
                label: 'The film is submitted by or on behalf of a political party? (please tick the relevant box)',
                apiID: '',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                span: 12,
                rule: { required: true }
            },
            {
                id: 'submitted-political-name',
                label: 'Name of Political Party',
                type: 'text',
                rule: {
                    baseIds: [`${INFORMATION_ON_FILM}-submitted`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${INFORMATION_ON_FILM}-submitted`] === 'Yes');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result =
                            Boolean(baseValues && baseValues[`${INFORMATION_ON_FILM}-submitted`] === 'No') ||
                            Boolean(baseValues && baseValues[`${INFORMATION_ON_FILM}-submitted`] === '');
                        return result;
                    }
                }
            },
            {
                id: 'checklist',
                label: 'I submit that the film should not be regarded as a Party Political Film for purposes of the Films Act, and can be shown or distributed as (please tick the relevant box): ',
                type: 'checkboxGroup',
                isRowDisplay: true,
                span: 12,
                options: [
                    {
                        optID: '1',
                        optLabel:
                            'a) it is a film which records live the whole or a material proportion of any performance, assembly of persons or procession that is held in accordance with the law and that does not depict any event, person or situation in a dramatic way;'
                    },
                    {
                        optID: '2',
                        optLabel:
                            'b) it is a film designed to provide a record of an event or occasion that is held in accordance with the law for those who took part in the event or occasion or are connected with those who did so;'
                    },
                    {
                        optID: '3',
                        optLabel: `c) it is a documentary without any animation and composed wholly of an accurate account depicting actual events, persons (deceased or otherwise) or situations, but not a film-
                        
                        i. wholly or substantially based on unscripted or 'reality' type programmes; or
                        
                        ii. that depicts those events, persons or situations in a dramatic way;`
                    },
                    {
                        optID: '4',
                        optLabel: `d) it is a film without animation and dramatic elements -
                        
                        i. composed wholly of a political party's manifesto or declaration of policies or ideology on the basis of which candidates authorised by the political party to stand will seek to be elected at a parliamentary election; and
                        
                        ii. made by or on behalf of that political party; or`
                    },
                    {
                        optID: '5',
                        optLabel: `e) it is a film without animation and dramatic elements -
                        
                        i. composed wholly of a candidate's declaration of policies or ideology on the basis of which the candidate will seek to be elected at a parliamentary or presidential election; and
                        
                        ii. made by or on behalf of that candidate.`
                    }
                    // {
                    //     optID: '6',
                    //     optLabel:
                    //         'I have exercised editorial oversight and ascertained the accuracy of the statements in the film. I agree that, as part of the assessment process, copies of the submitted film may be made for relevant persons involved in the process (please tick).'
                    // }
                ],
                rule: {
                    baseIds: [`checklist`],
                    required: true,
                    validationMessage: 'Please tick the relevant box'
                }
            },
            {
                id: 'i-have-exercised-editorial',
                label: 'I have exercised editorial oversight and ascertained the accuracy of the statements in the film. I agree that, as part of the assessment process, copies of the submitted film may be made for relevant persons involved in the process (please tick).',
                type: 'checkbox',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'remarks',
                label: 'Please provide any other information that may be useful for the assessment of the film. (Please indicate "N/A" if not possible)',
                placeholder: 'Free Text',
                type: 'longText',
                textRows: 4,
                span: 12,
                rule: {
                    required: true
                }
            }
        ]
    }
];

export default SUBMISSION_OF_FILMS_WITH_PARTY_POLITICAL_CONTENT;
